"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalFooterControls = exports.modalFooterContent = exports.modalFooter = exports.modalContent = exports.modalTitle = exports.modalCloseButtonWrapper = exports.modalCloseButton = exports.modalOverlay = exports.modal = void 0;
const tailwind_variants_1 = require("tailwind-variants");
const tw_1 = require("../utils/tw");
exports.modal = (0, tailwind_variants_1.tv)({
  base: `
    relative mb-none flex size-full animate-slide-up-full-300 flex-col items-end
    rounded-2xs border-light bg-primary
    data-[exit]:animate-slide-down-full-300
    md:mb-auto md:h-auto md:max-h-[53.5rem] md:w-[50rem] md:animate-fade-in-300
    md:data-[exit]:animate-fade-out-300
    [&:not(:has([sparkModalTitle]))]:pt-[80px]
  `,
  variants: {
    size: {
      extraSmall: `
        mb-auto h-[23rem] w-[25rem]
        md:w-[30rem]
      `,
      small: `
        max-h-[50%] pt-xl
        before:absolute before:left-1/2 before:top-xl before:h-[6px]
        before:w-[40px] before:-translate-x-1/2 before:-translate-y-1/2
        before:rounded-md before:bg-neutral-active before:content-[""]
        md:w-[40rem] md:pt-none md:before:content-none
      `,
      medium: `
        max-h-[80%] pt-xl
        before:absolute before:left-1/2 before:top-xl before:h-[6px]
        before:w-[40px] before:-translate-x-1/2 before:-translate-y-1/2
        before:rounded-md before:bg-neutral-active before:content-[""]
        md:w-[50rem] md:pt-none md:before:content-none
      `,
      large: [`md:w-[64rem]`]
    }
  }
});
exports.modalOverlay = (0, tw_1.tw)(`
  fixed inset-none flex animate-fade-in-300 items-center justify-center
  bg-tertiary/50 backdrop-blur-sm
`);
// This style is not using `tw` because it needs py and px to be set
// separately to override default sparkButton styles.
exports.modalCloseButton = `bg-primary py-sm px-sm`;
exports.modalCloseButtonWrapper = (0, tw_1.tw)(`
  absolute top-none z-10 h-fit p-xl
  md:-inset-y-[40px] md:p-none
`);
exports.modalTitle = (0, tw_1.tw)(`
  border-b relative flex w-full items-baseline gap-md border-light p-xl
  pr-[56px] text-xl font-bold leading-lg text-primary
  md:pr-xl
`);
exports.modalContent = (0, tw_1.tw)(`
  peer flex flex-1 flex-col gap-xl self-stretch overflow-y-auto p-xl
`);
exports.modalFooter = (0, tw_1.tw)(`
  border-t flex w-full flex-col items-center gap-md self-stretch rounded-b-2xs
  border-light p-xl
  peer-[[data-overflowing="true"]]:shadow-[0px_-4px_14px_0px_rgba(0,0,0,0.10)]
  md:flex-row md:justify-between md:self-stretch
`);
exports.modalFooterContent = (0, tw_1.tw)(`
  order-last
  md:order-first
`);
exports.modalFooterControls = (0, tw_1.tw)(`
  flex flex-col gap-md self-stretch
  md:flex-row md:justify-end md:self-stretch
`);
